import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "Curiosity",
  "Coins",
  "Kindness",
  "Compound joy",
  "Little decisions",
  "Big questions",
  "Saving",
  "Sharing",
  "Wonder",
];

export default function EditorialMarquee() {
  return (
    <section className="py-16 md:py-24 border-y border-stone-900/10" data-testid="marquee-section">
      <Marquee speed={22} gradient={false} pauseOnHover={false}>
        <div className="marquee-text">
          {WORDS.map((w, i) => (
            <span key={i}>
              {w}
              <span className="marquee-diamond">✦</span>
            </span>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
